'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('parking', {
      url: '/account/parking',
      template: '<parking></parking>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/parking/parking.routes.js